module.exports = __webpack_public_path__ + "img/generate-02.6048610f.png";